import { memo, useMemo } from "react";

import { Chart } from "primereact/chart";

import { Chart as ChartJS } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";

ChartJS.register(annotationPlugin);

export const GraficoRelacaoProdRes = memo(function GraficoRelacaoProdRes({
  months,
  producao_geral,
  residuos,
  setor,
  graficoComMeta = false,
  setores = [],
}) {
  const meta = useMemo(() => {
    if (!graficoComMeta) return 0;
    const setorEncontrado = setores.find((s) => s.nome === setor);
    return setorEncontrado?.meta_residuo ?? 0;
  }, [graficoComMeta, setores, setor]);

  const chartOptions = useMemo(
    () => ({
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          anchor: "end",
          align: "end",
          formatter: (value) =>
            Intl.NumberFormat("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(value) + "%",
          font: {
            size: 14,
            weight: "bold",
          },
          color: "#2c3e50",
        },
        annotation: graficoComMeta
          ? {
              annotations: {
                line1: {
                  type: "line",
                  yMin: meta? meta : 0,
                  yMax: meta? meta : 0,
                  borderColor: "rgb(255, 99, 132)",
                  borderWidth: 2,
                },
              },
            }
          : {},
      },
    }),
    [meta, graficoComMeta]
  );
  
  const chartData = useMemo(() => {
    const filteredData = (producao_geral ?? []).filter(
      (e) => e.setor === setor
    );
    const filteredDataRes = (residuos ?? []).filter((e) => e.setor === setor);

    const data = [];

    for (let i = 1; i <= 12; i++) {
      const prod = filteredData.filter((e) => parseInt(e.mes) === i);
      const res = filteredDataRes.filter(
        (e) => parseInt(e.mes) === i && Number(e.soma) > 0
      );

      let producaoTotal = 0;
      let residuosTotal = 0;

      for (const item of res) {
        const base = item.somaemkg ?? item.soma;
        if (base !== null && base !== undefined)
          residuosTotal += parseFloat(base);
      }

      for (const item of prod) {
        const base = item.somaemkg ?? item.soma;
        if (base !== null && base !== undefined)
          producaoTotal += parseFloat(base);
      }

      if (prod.length === 0 || res.length === 0) {
        data.push(0);
      } else {
        data.push(
          producaoTotal > 0 ? (residuosTotal / producaoTotal) * 100 : 0
        );
      }
    }

    return {
      labels: months,
      datasets: [
        {
          backgroundColor: "#48dbfb",
          data,
          label: "% Resíduo / Produção",
        },
      ],
    };
  }, [months, producao_geral, residuos, setor]);

  return (
    <div>
      <Chart
        data={chartData}
        height="350px"
        options={chartOptions}
        plugins={[ChartDataLabels]}
        type="bar"
      />
    </div>
  );
});
